export default {
  filters: ["vendor", "source", "showcode"],
  ExcludeCustomerByAccountType: ""
};
